import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();
  const [registryId, setRegistryId] = useState<string | null>(null);

  useEffect(() => {
    try { setRegistryId(sessionStorage.getItem('payhere_registry_id')); } catch {}
  }, []);

  const handleBackToRegistry = () => {
    try { sessionStorage.removeItem('payhere_registry_id'); } catch {}
    if (registryId) {
      navigate(`/registries/${registryId}`);
    } else {
      navigate('/');
    }
  };

  const handleClose = () => {
    try { sessionStorage.removeItem('payhere_registry_id'); } catch {}
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-pastel-gradient flex items-center justify-center p-4">
      <div className="card-pastel p-8 sm:p-10 max-w-md w-full text-center space-y-6">
        <div className="flex justify-center">
          <div className="bg-red-50 p-5 rounded-full">
            <XCircle className="w-10 h-10 text-red-400" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-bold text-gray-800 font-poppins">Payment Cancelled</h1>
          <p className="text-gray-600 font-poppins text-sm">
            Your payment was cancelled and no charges were made. You can go back to the gift registry to try again.
          </p>
        </div>

        <div className="space-y-3 pt-2">
          <button
            onClick={handleBackToRegistry}
            className="w-full flex items-center justify-center gap-2 px-5 py-3 bg-primary text-white rounded-xl hover:bg-primary-600 transition-colors font-medium font-poppins text-sm"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Gift Registry
          </button>
          <button
            onClick={handleClose}
            className="w-full px-5 py-3 bg-white/60 text-gray-600 rounded-xl hover:bg-white/80 transition-colors font-poppins text-sm"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
